import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import HiddenHorizontalScrollbar from '@/components/HiddenHorizontalScrollbar.vue';
import TextRecommendationEmpty from '@/features/why-to-watch/components/TextRecommendationEmpty.vue';
import Top10TitleSwiper from '@/components/popular/provider-module/Top10TitleSwiper.vue';
import TextRecommendationCardTitleDetail from '@/features/why-to-watch/components/TextRecommendationCardTitleDetail.vue';

import { TitleDetail } from '@/interfaces/title-details-graphql';
import { useLanguageStore, useUserStore } from '@/helpers/composables/useStores';

import {
	GetTextRecommendationsDocument,
	GetTextRecommendationsQuery,
	GetTextRecommendationsQueryVariables,
} from '@/features/why-to-watch/graphql/queries/GetTextRecommendations.query';

import { useQuery } from '@/helpers/composables/useApollo';
import { SnowplowContext } from '@/helpers/tracking/providers';


export default /*#__PURE__*/_defineComponent({
  __name: 'TextRecommendations',
  props: {
    title: null,
    additionalContexts: null
  },
  setup(__props: any) {

const props = __props as {
	title: TitleDetail;
	additionalContexts: SnowplowContext[];
};



const { language, country } = useLanguageStore();
const { isAdmin, isEditor } = useUserStore();

const { result } = useQuery<GetTextRecommendationsQuery, GetTextRecommendationsQueryVariables>(
	GetTextRecommendationsDocument,
	() => ({
		language: language.value,
		country: country.value,
		jwEntityId: props.title.id,
	}),
	{
		errorPolicy: 'all',
	}
);

const textRecommendations = computed(() => result.value?.textRecommendations ?? []);

const singleTextRecommendation = computed(() => textRecommendations.value.length === 1);

const showTextRecommendationTools = computed(() => isAdmin.value || isEditor.value);

return { __sfc: true,props, language, country, isAdmin, isEditor, result, textRecommendations, singleTextRecommendation, showTextRecommendationTools, HiddenHorizontalScrollbar, TextRecommendationEmpty, Top10TitleSwiper, TextRecommendationCardTitleDetail }
}

})